// Legacy global styles. Must import first b/c it's assumed they are overridden
// by all other styles (they used to be included in a style tag prior to JS).
import '../../assets/css/app.global.css';

import { AppComponent } from './app.component';
import ngMessages from 'angular-messages';
import { AppConfig } from './app.config';
import { AuthModule } from './auth';
import { ErrorHandlerModule } from './error-handler';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngAnimate from 'angular-animate';
import { AppHeaderModule } from '../app-header';
import footer from '../footer';
import store from '../../state/store';
import account from '../account';
import { StepsModule } from '../steps';
import { EnvironmentService } from '../../environment';
import { AnalyticsModule } from './analytics';
import ServicesModule from '../common/services';
import RolesModule from '../common/roles/roles';
import { ErrorsModule } from '../errors';
import { DirectivesModule } from '../common/directives';
import ValidatorsModule from '../common/validators';
import FiltersModule from '../common/filters';
import HelpersModule from '../common/helpers/helpers';
import SignInModule from '../sign-in/sign-in';
import { DashboardModule } from '../dashboard';
import { VerifyModule } from '../verify';
import { WelcomeModule } from '../welcome';
import { InviteModule } from '../invite';
import BreadcrumbModule from '../common/directives/breadcrumb/breadcrumb';
import { ForgotPasswordModule } from '../forgot-password';
import { UnsubscribeModule } from '../unsubscribe';
import RedirectModule from '../redirect/redirect';
import GetStartedModule from '../get-started/get-started';
import DisableGetCache from '../helpers/disable-get-cache/disable-get-cache';
import StateConfigModule from './state-config';
import MicroAppRouterFixModule from '../helpers/micro-app/micro-app-router-fix.module';
import { NewProductIntroModule } from '../new-product-intro';
import { NextStepModule } from '../next-step';
import { Module as InsuranceModule } from '../insurance-questionnaire/insurance-questionnaire.module';

export const AppModule = angular
  .module('app', [
    MicroAppRouterFixModule.name,
    uiRouter,
    ngMessages,
    AuthModule.name,
    ErrorHandlerModule.name,
    ServicesModule.name,
    EnvironmentService.name,
    RolesModule.name,
    AnalyticsModule.name,
    AppHeaderModule.name,
    ErrorsModule.name,
    DirectivesModule.name,
    ValidatorsModule.name,
    FiltersModule.name,
    HelpersModule.name,
    SignInModule.name,
    DashboardModule.name,
    VerifyModule.name,
    WelcomeModule.name,
    account.name,
    StepsModule.name,
    InviteModule.name,
    BreadcrumbModule.name,
    ForgotPasswordModule.name,
    UnsubscribeModule.name,
    RedirectModule.name,
    GetStartedModule.name,
    ngAnimate,
    DisableGetCache.name,
    StateConfigModule.name,
    footer.name,
    store.name,
    NewProductIntroModule.name,
    NextStepModule.name,
    InsuranceModule.name,
  ])
  .config(AppConfig)
  .component('updMoverApp', AppComponent);
